export default __webpack_public_path__ + "static/media/kitchen3-after1-768w.e9260527.png";